export const logosCreatedBy = [
    {
        src: 'UPE.png',
        alt: 'logo upe',
        link: 'https://caruaru.upe.br/'
    },
    {
        src: 'react.png',
        alt: 'logo react research labs',
        link: 'https://caruaru.upe.br/react/'
    }
]

export const logosSources = [
    {
        src: 'agileConnection.png',
        alt: 'logo Agile connection',
        link: 'https://www.agileconnection.com/'
    },
    {
        src: 'scrum.png',
        alt: 'logo Scrum',
        link: 'https://www.scrum.org/'
    },
    {
        src: 'agileAlliance.png',
        alt: 'logo Agile Alliance',
        link: 'https://www.agilealliance.org/'
    },
    {
        src: 'scrumAlliance.png',
        alt: 'logo Scrum Alliance',
        link: 'https://www.scrumalliance.org/'
    },
]